<div class="product-options-box customize-box p-4">
    <h5 class="mb-4 fw-semibold">Customize It</h5>
    <!-- Options -->
    <div class="mb-1" *ngFor="let optionGroup of productOptionsDisplay; let i= index">
        <label class="form-label">Option: {{ optionGroup.option_group_name }}
            <span class="require" *ngIf="optionGroup.is_required == 1">
                *
            </span>
        </label>
        <select class="form-select" [name]="'product_option_'+optionGroup?.product_option_group_key"
            [id]="'product_option_'+optionGroup?.product_option_group_key"
            [(ngModel)]="groups[optionGroup?.product_option_group_key]"
            (ngModelChange)="onOptionChange($event,optionGroup?.product_option_group_key,i)">
            <option value="">Choose Option</option>
            <ng-container *ngFor="let option of optionGroup.product_option">
                <option [value]="option.product_option_key">
                    <!-- Display option based on its type -->
                    <ng-container *ngIf="option.option_type === 'enter_option_name'">
                        {{ option.option_name }} ({{ option.price_adjustment }} ${{ (+option.price *
                        +option.add_to_cart_qty | decimal) }})
                    </ng-container>
                    <ng-container *ngIf="option.option_type === 'select_product_sku'">
                        {{ option.option_sku_name }}-{{ option.assigned_sku }} ({{
                        option.price_adjustment | titlecase }} {{'$'+(+option.add_to_cart_qty *
                        +option?.price | decimal) || '' }})
                    </ng-container>
                    <ng-container *ngIf="option.option_type === 'replace_product_sku'">
                        <ng-container
                            *ngIf="option?.option_sku_name?.length > 0 || option?.option_name?.length > 0  else showOptionAssignedSku">
                            {{ option.option_sku_name }}-{{ option.assigned_sku }}
                        </ng-container>
                        <ng-template #showOptionAssignedSku>
                            {{option.assigned_sku}}
                        </ng-template>
                    </ng-container>
                </option>
            </ng-container>
        </select>
    </div>
</div>